import { MapMutationTypes } from './types'

export const mutations = {
  [MapMutationTypes.SetMapOrdersCollection](state, { map_orders, pageCount, itemCount }) {
    state.mapOrders = map_orders
    state.pageCount = pageCount
    state.itemCount = itemCount
  },
}
